import { useSessionStore } from "@/hooks/useStore";


export const getMessages = (msg, htmlStr, hot) => {
  const currentWindow = useSessionStore.get("userAgree") !== "true";
  const MessagesList = [
    {
      type: "system",
      content: {
        text: "智能助理进入对话，为您服务",
      },
    },
    // {
    //   type: "text",
    //   content: {
    //     text: msg,
    //   },
    // },
  ];


  if (msg) {
    MessagesList.push({
      type: "text",
      content: {
        text: msg,
      },
    })
  }
  if (currentWindow) {
    if (htmlStr) {
      MessagesList.push({
        type: "disclaimer",
        content: {
          code: "disclaimer",
          disclaimer: htmlStr,
          hottopic: hot,
        },
      });
    }

    if (hot && hot.length > 0) {
      MessagesList.push({
        type: "hot",
        content: {
          code: "hot",
          hottopic: hot,
        },
      });
    }

  } else if (hot?.length > 0) {
    MessagesList.push({
      type: "hot",
      content: {
        code: "hot",
        hottopic: hot,
      },
    });
  }
  return MessagesList;
};

export const SysMessage = (message) => {
  return {
    _id: new Date().getTime().toString(),
    type: "system",
    content: {
      text: message,
    },
    hasTime: false,
  };
};

export const TextMessage = (
  msg,
  position = "right"
) => {
  return {
    _id: new Date().getTime().toString(),
    type: "text",
    content: {
      text: msg,
    },
    position,
    hasTime: false,
  };
};

export const HtmlMessage = (html) => {
  return {
    _id: new Date().getTime().toString(),
    type: "html",
    content: {
      code: "html",
      data: html,
    },
    hasTime: false,
  };
};

export const CardMessage = (code) => {
  return {
    _id: new Date().getTime().toString(),
    type: "card",
    content: {
      code: code,
    },
    hasTime: false,
  };
};

export const KnowledgeGraphMsg = (data) => {
  return {
    _id: new Date().getTime().toString(),
    type: "text",
    content: {
      text: data.displayMsg,
    },
    meta: {
      modelType: 2,
      trueQueryText: data.trueQueryMsg,
      queryPath: data.queryPath,
    },
    hasTime: false,
  };
};

export const RobotFakeKnowledgeGraphMsg = (
  msg,
  items
) => {
  return {
    _id: new Date().getTime().toString(),
    type: "card",
    content: {
      code: "CardRobotFakeKnowledgeGraphMsg",
      data: {
        query: msg,
        items: items,
      },
      text: msg,
    },
    position: "left",
    hasTime: false,
  };
};



// 静默发送，没有UI交互
export const BgCmdMessage = (msg) => {
  return {
    msgType: "command",
    msgData: {
      qId: msg.msgId,
      query: "",
      command: msg.command,
    },
  };
};
